"use strict";

import "./dialog-share.scss";
import angular from "angular";
import _ from "lodash";
import { dialogEmailModelTemplate } from "../../../reports.dialog-templates";

import { Accounting } from "../../../../../../../gateway/Accounting/Accounting";
import { Report } from "../../../../../../../gateway/Report/Report";
import { UserDataAdapter } from "../../../../../../../presentation/adpters/UserDataAdapter";
import { EmailSESService } from "../../../../../../../presentation/services/EmailSES/EmailSES";
import { Events } from "../../../../../../../presentation/services/Events/Events";
import { PointsAccountingAnalytics } from "../../../../../../../presentation/services/PointsAccountingAnalytics/PointsAccountingAnalytics";
import { EventScoreService } from "../../../../../../../presentation/services/Score/event-score.service";
import { ShareHistory } from "../../../../../../../presentation/services/ShareHistory/ShareHistory";
import { SourceConvert } from "../../../../../../../presentation/services/SourceConvert/SourceConvert";
import toastCustomTemplate from "../../../../../../../shared/components/nu-toast-custom/toast-custom.component.html";
import { GetUserUsecase } from "../../../../../../../usecases";
import { AnonymousUser } from "../../../../../../../utils/users-roles/users-roles";

export class DialogShareCtrl {
    constructor(
        $mdDialog,
        $stateParams,
        locals,
        DSNDialogService,
        toast,
        $scope
    ) {
        this.$mdDialog = $mdDialog;
        this.$stateParams = $stateParams;
        this.toast = toast;
        this.$scope = $scope;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.EmailSESService = new EmailSESService();
        this.Accounting = new Accounting();
        this.Report = new Report();
        this.ShareHistory = new ShareHistory({ Report: this.Report });
        this.PointsAccountingAnalytics = new PointsAccountingAnalytics();
        this.EventScore = new EventScoreService();
        this.users = [];
        this.accounting = {};
        this.user = new UserDataAdapter().user();
        this.emailsCount = 0;
        this.Events = new Events();
        this.accountingId = this.$stateParams.accountingId;
        this.isSelected = false;
        this.group = [];
        this.usersAnonymous = [];
        this.company = locals.company;
    }

    $onInit() {
        this.Events.setParamns({
            companyId: this.locals.company._id
        });
        this._setAccountingDocument();
    }

    async _setAccountingDocument() {
        this.accounting = await this.Accounting.getById(this.accountingId);
    }

    _getUsersSelecteds(field) {
        let userIds = [];

        let typesUsers = [
            "Contabilidade",
            "Contabil",
            "Comercial",
            "Fiscal",
            "Pessoal",
            "Financeiro",
            "Gestor",
            "Pessoal e Fiscal",
            "Nucont",
            "Empresa",
            "Contatos"
        ];

        if (this.company.isGroup) {
            for (let gp of this.group) {
                userIds = gp.users
                    .filter((u) => u.selected)
                    .map((u) => u[field])
                    .concat(userIds);
            }
        }

        for (let userType of typesUsers) {
            if (this.users[userType])
                userIds = this.users[userType]
                    .filter((u) => u.selected)
                    .map((u) => u[field])
                    .concat(userIds);
        }

        return userIds;
    }

    async sendEmailAnonymous() {
        const sourceHumam = SourceConvert.toHuman(
            _.get(this.locals, "report.sources")
        );
        this.Events.send(`Relatorio.Compartilhar.Anonimo.${sourceHumam}`);
        const fromCompany =
            this.user.roles.indexOf("Empresa") > -1
                ? _.get(this.locals.company, "name")
                : this.accounting.name;
        const usernames = this.usersAnonymous;
        this.emailsCount = usernames.length;
        const tokenObject = await this._generateToken();
        const from = { name: this.accounting.name, email: this.user.username };
        const emails = {
            subject: `Relatório de performance da ${_.get(
                this.locals,
                "company.name"
            )}`,
            from,
            bodyOptions: {
                reference: "CompartilharRelatorio",
                defaultParams: {
                    subject: `Relatório de performance da ${_.get(
                        this.locals,
                        "company.name"
                    )}`,
                    companyLogo:
                        _.get(this.locals.company, "picture") ||
                        "https://nucont-imgs.s3.amazonaws.com/email-default-company-logo.png",
                    fromCompany: fromCompany || "",
                    companyName: _.get(this.locals, "company.name"),
                    comment: this.commentEmail || "",
                    url: this._getLiveTokenUrl(
                        tokenObject._id,
                        tokenObject.token
                    )
                }
            },
            to: []
        };
        for (let index = 0; index < usernames.length; index++) {
            emails.to.push({
                email: usernames[index],
                name: usernames[index],
                dynamicParams: {
                    toName: usernames[index]
                }
            });
        }
        try {
            const response = await this.EmailSESService.sendBulk(emails);

            if (response) this.showToastSuccess();
        } catch (error) {
            this.showToastError();
            console.error("error", error);
        }
    }

    _getLiveTokenUrl(userId, token, companyContact, userIdentify) {
        const baseUrl = publicSettings.url;
        let url = "";
        const types = {
            dashboard: "dashboard",
            monitoring: "regras",
            dre: "dre",
            balance: "balanco"
        };
        if (token)
            url = `${baseUrl}/relatorio/${this.locals.company._id}/${this.locals.accountingId}/${this.locals.report.type}/${userId}/${this.locals.report._id}?liveToken=${token}`;
        else
            url = `${baseUrl}/contabilidade/${
                this.locals.accountingId
            }/empresa/${this.locals.company._id}/relatorios/${
                types[this.locals.report.type]
            }/${this.locals.report._id}?`;
        if (companyContact && token)
            url = `${url}&contactId=${companyContact._id}`;
        if (token && !companyContact)
            url = `${url}&userIdentify=${userIdentify}`;
        return url;
    }

    emailModel() {
        this.DSNDialogService.custom({
            multiple: true,
            clickOutsideToClose: false,
            controller: "emailModelCtrl",
            controllerAs: "$ctrl",
            locals: {
                width: "382px",
                title: "Compartilhar por Email",
                templateHtml: dialogEmailModelTemplate
            },
            after: {
                hide: (response) => {
                    if (response) {
                        this.EventScore.onReportShared(
                            this.$stateParams.accountingId,
                            this.locals.company._id,
                            this.locals.report.sources
                        );
                    }
                }
            }
        });
    }

    async _generateToken() {
        const getUserUsecase = new GetUserUsecase();
        const userAnonymous = await getUserUsecase.execute({
            username: AnonymousUser.email
        });
        const token = userAnonymous.getLastToken();
        return {
            token,
            userAnonymous: userAnonymous.props,
            _id: userAnonymous.props._id
        };
    }

    async onSubmitShare() {
        this.loading = true;
        if (this.locals.action) this.locals.action.shared();
        if (this.usersAnonymous.length) await this.sendEmailAnonymous();
        const userIds = this._getUsersSelecteds("_id");
        if (!userIds.length && !this.usersAnonymous.length) return;
        let shared = _.union(userIds, this.locals.report.shared) || [];
        if (this.usersAnonymous.length) shared.push(...this.usersAnonymous);
        try {
            await this.Report.updateOne(this.locals.report._id, {
                shared: _.uniq(shared)
            });
            this.ShareHistory.setReportShareHistory(
                "email",
                this.locals.report._id,
                "USER_EMAIL"
            );
            this.$mdDialog.hide(true);
            this.$scope.$applyAsync();
        } catch (ex) {
            console.error("ex", ex);
            this.$mdDialog.cancel();
        } finally {
            this.loading = false;
        }
    }

    showToastSuccess() {
        this.toast.show("", "bottom right", {
            hideDelay: 3000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: "Relatório enviado com sucesso!",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    showToastError() {
        this.toast.show("", "bottom right", {
            hideDelay: 3000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: "Falha ao enviar email.",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }
}

angular
    .module("nucont")
    .controller("DialogShareCtrl", [
        "$mdDialog",
        "$stateParams",
        "locals",
        "DSNDialogService",
        "toast",
        "$scope",
        DialogShareCtrl
    ]);
